import { Navigate,Outlet } from "react-router-dom";

import useStateHandler from "@/hooks/useStateHandler";

export default function TypeOfAccountRequired({ allowedTypes }) {
  const { state } = useStateHandler();
  const userType = String(state.user_session?.user_type || "").toLowerCase();
  const normalizedAllowedTypes = (allowedTypes || []).map((type) => String(type || "").toLowerCase());
  const hasGalleryAccess = Boolean(state.user_session?.gallery_id)
    && (state.user_session?.gallery_member?.status ?? "accepted") === "accepted";

  const isAllowed = normalizedAllowedTypes.includes(userType)
    || (normalizedAllowedTypes.includes("gallery") && hasGalleryAccess);

  if(isAllowed) {
    return (
      <Outlet/>
    );
  } else {
    return (
      <Navigate to="/" replace/>
    );
  }
}
